import React from 'react'

import { SiteDate } from '../components/booking-form/booking-form.component'

export const metresToMiles = (metres: number) => {
  const METRE_TO_MILE = 0.000621371

  return (metres * METRE_TO_MILE).toFixed(1)
}

export const getDateOptions = (dates: SiteDate[] = [], dayClass = '') => {
  return dates.map(({ date, totalAppointmentSlotsCount }) => {
    const dateObj = new Date(date)

    const dayStr = dateObj.toLocaleDateString('en-GB', { weekday: 'long' })
    const monthStr = dateObj.toLocaleDateString('en-GB', { month: 'short' })

    return {
      children: (
        <>
          <span className={dayClass}>{dayStr}</span>
          {monthStr} {dateObj.getDate()}
        </>
      ),
      value: date,
      disabled: !totalAppointmentSlotsCount,
    }
  })
}

export const getTimeOptions = (dates: SiteDate[] = [], selectedDate: string | null) => {
  const date = dates.find((d) => d.date === selectedDate)

  return date
    ? date.timeSlots.map((slot) => ({
        children: slot.timeSlot.replace(':00', ''),
        value: slot.slotIds[0],
      }))
    : []
}
